import { isBackKey } from './remoteKeys';

export type BackKeyHandler = (event: KeyboardEvent) => void;

interface DialogLayer {
  id: number;
  backKeyHandler: BackKeyHandler;
}

let layers: DialogLayer[] = [];
let nextId = 0;
let installed = false;

const handleKeyDown = (event: KeyboardEvent) => {
  if (layers.length === 0 || !isBackKey(event)) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  layers[layers.length - 1].backKeyHandler(event);
};

const handleKeyUp = (event: KeyboardEvent) => {
  if (layers.length === 0 || !isBackKey(event)) return;
  event.preventDefault();
  event.stopImmediatePropagation();
};

export const installBackKeyLayers = () => {
  if (installed) return;
  installed = true;
  window.addEventListener('keydown', handleKeyDown, true);
  window.addEventListener('keyup', handleKeyUp, true);
};

/**
 * Registers a back key layer on top of the stack.
 * @returns a function that removes the layer again
 */
export const pushBackKeyLayer = (handler: BackKeyHandler) => {
  installBackKeyLayers();
  const id = nextId++;
  layers.push({ id, backKeyHandler: handler });
  return () => {
    layers = layers.filter((layer) => layer.id !== id);
  };
};

export const hasBackKeyLayers = () => layers.length > 0;
